var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{staticClass:"progress is-small is-primary",attrs:{"max":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }